export * as analyticsData from '@wix/auto_sdk_analytics-data_analytics-data/meta';
